import React from 'react';
import { Accessibility as AccessibilityIcon } from 'lucide-react';

export const Accessibility = () => {
  return (
    <div className="min-h-screen py-20 bg-gradient-to-br from-hr-warm-bg via-white to-hr-purple-light/10 relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-hr-purple/5 rounded-full blur-3xl animate-float" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-hr-teal/5 rounded-full blur-3xl animate-float-slow" />
      
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <article className="bg-white rounded-2xl shadow-2xl p-8 lg:p-12 animate-fade-in-up">
          <header className="mb-12 text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-hr-purple-light mb-6 animate-bounce-subtle">
              <AccessibilityIcon className="h-8 w-8 text-hr-purple" />
            </div>
            <h1 className="font-heading text-3xl sm:text-4xl font-bold text-hr-text-primary mb-4 animate-fade-in-up stagger-1" style={{ opacity: 0 }}>
              Accessibility Statement
            </h1>
            <p className="text-hr-text-muted animate-fade-in-up stagger-2" style={{ opacity: 0 }}>Last Updated: 1/15/2026</p>
          </header>

          <div className="prose prose-lg max-w-none text-hr-text-secondary animate-fade-in-up stagger-3" style={{ opacity: 0 }}>
            <p className="lead">
              HR Nest, LLC is committed to ensuring digital accessibility for all users, including individuals with disabilities. We strive to make our website accessible and usable for everyone in accordance with applicable accessibility standards.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">Our Commitment</h2>
            <p>
              We aim to follow the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA, where reasonably possible, to improve accessibility and usability.
            </p>

            <p>Our ongoing efforts include:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Clear navigation and readable content</li>
              <li>Alternative text for images where applicable</li>
              <li>Keyboard navigation support</li>
              <li>Accessible color contrast and font sizing</li>
            </ul>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">Limitations</h2>
            <p>
              While we strive to ensure accessibility across all areas of our website, some content may not yet be fully accessible. We are continuously working to improve our digital experience.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-hr-text-primary mt-12 mb-4">Need Assistance?</h2>
            <p>
              If you experience difficulty accessing any part of our website or need assistance, please contact us:
            </p>
            <p>📧 HRnestllc@gmail.com</p>
            <p>
              We welcome feedback and will make reasonable efforts to accommodate accessibility requests.
            </p>
          </div>
        </article>
      </div>
    </div>
  );
};

export default Accessibility;
